import {useState} from 'react';
import styles from '../Applicants/css/display-applicant.module.css';
import { useQuery } from '@tanstack/react-query';
import {AiOutlineSearch as SearchIcon} from 'react-icons/ai';
import {IoReload as ReloadIcon} from 'react-icons/io5';
import apiCall from '../../../utils/apiCall';
import { CircularProgress, styled } from '@mui/material';
import { AxiosError } from 'axios';
import { FilterDropDown,DateFilter} from '../../../ui-components';
import OldApplicantTable from './OldApplicantTable';
import { ExNyRoute,PrRoute, ExRoute, AcRoute, MiRoute,  CoRoute } from '../../../utils/allRouteId';


interface OldApplicants {
    Id: number;
    IsNewApplicant: boolean;
    Name: string;
    PreviousEmail: string;
    PhoneNumber: string;
    ApplicationType: string;
    Status: string;
  }

const DisplayOldApplicants = (props:any) =>{

    const routeOptions = [
        {name:'All',val:0},
        {name:'Examination',val:ExNyRoute},
        {name:'Academic',val:PrRoute},
        {name:'Practitioner',val:ExRoute},
        {name:'Executive',val:AcRoute},
        {name:'Military',val:MiRoute},
        {name:'Corporate',val:CoRoute}
    ]

    const  applicationStatusOptions = [
        {name:"NewEntry",val:'1', dis: 'New Entry'},
        {name:"Treated",val:'2', dis: 'Treated'},
        {name:"Reject",val:'3', dis: 'Rejected'}
    ]


    const [filter,setFilter] = useState<any>(null);
    //const optb = useMemo(()=>opt2,[opt2])
    const [appStatus,setAppStatus] = useState('NewEntry');
    const [appStatusDis, setAppStatusDis] = useState('')
    const [appRoute,setAppRoute] = useState<any>(null);
    const [searchData, setSearchData] = useState('')

    const switchAppStatus = (data : {val: string, name: string, dis: string}) => {
        setAppStatus(data?.name)
        setAppStatusDis(data?.dis);
    }

    const getAllExistingApplicants = async (): Promise<OldApplicants[]> => {
        return  (await apiCall().get(`/Applicant/GetApplicantExistingById?typeId=${appStatus}`))?.data?.Data
    }

    const getAllExistingApplicantsQuery = useQuery([`get-All-Existing-Applicants`, searchData, appStatus ], getAllExistingApplicants, {retry: 1, refetchOnWindowFocus: false});

    const getAllExistingApplicantsData = getAllExistingApplicantsQuery?.data;
    const getAllExistingApplicantsError = getAllExistingApplicantsQuery?.error as AxiosError;

    const filteredData = getAllExistingApplicantsData?.filter(x => (
        Object.values(x).join(" ").toLowerCase().includes(searchData.toLowerCase())  //&& (appRoute && appRoute.name)?Object.values(x).join(" ").toLowerCase().includes(appRoute.name.toLowerCase()) :true 
      ));
  
    return (     
        <div className={styles.container}>
            <div className={styles.filterDiv}>
            <label className={styles.searchForm} ><span className={styles.sI}><SearchIcon/></span><input value = {searchData} onChange={(e) => setSearchData(e.target.value)} type="text" placeholder='Search' /><button className={styles.rBtn} type="submit"><ReloadIcon/></button></label>
                <FilterDropDown onChange={switchAppStatus} text={appStatusDis ? appStatusDis : 'Applicant Status'} bg="#0A3922" color="#fff" options={applicationStatusOptions} />
                {/* <FilterDropDown onChange={setAppRoute} text="Route" bg="#E2E4E9" options={routeOptions} /> */}
                {/* <DateFilter  /> */}
            </div>
            <div>
            {getAllExistingApplicantsQuery?.isFetching ? (
                  <CircularProgress 
                    sx={{
                      fontSize: '1rem',
                      marginInline: 'auto',
                      display: 'block',
                      marginBlock: '2rem'
                    }}
                  />
              ) : getAllExistingApplicantsQuery.isError ? (
                  <StyledError>{getAllExistingApplicantsError?.message}</StyledError>
              ) : filteredData && filteredData?.length > 0 ? 
                <OldApplicantTable data={searchData?.length > 0 ? filteredData : getAllExistingApplicantsData} />
                : <NoResult>No Results</NoResult>}
            </div>
        </div>
    )
  }

  export default DisplayOldApplicants;

  const StyledError = styled('p')`
  color: red;
  font-size: 1.4rem;
  display: flex;
`

const NoResult = styled('div')`
  margin-block-start: 0px;
`